import type { TFunction } from 'i18next';

export const ACTIVE_ORDER_STATUSES: string[] = ['PENDING', 'PAYMENT_REVIEW', 'CONFIRMED'];
export const PAST_ORDER_STATUSES: string[] = ['DONE', 'CANCELLED'];

export const ORDER_STATUS_COLORS: Record<string, string> = {
  PENDING: 'var(--surface-container-high)',
  PAYMENT_REVIEW: 'var(--color-accent)',
  CONFIRMED: 'var(--color-success)',
  DONE: 'var(--color-success)',
  CANCELLED: 'var(--color-error)',
};

export const ORDER_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pending',
  PAYMENT_REVIEW: 'Payment Review',
  CONFIRMED: 'Confirmed',
  DONE: 'Completed',
  CANCELLED: 'Cancelled',
};

export function getOrderStatusLabel(status: string, t: TFunction): string {
  return t(`orderStatus.${status}`, {
    defaultValue: ORDER_STATUS_LABELS[status] ?? status,
  });
}
